<router-outlet></router-outlet>
<app-loading *ngIf="loading"></app-loading>
<ng-container *ngIf="isUserLoggedIn">

    <div class="chat-bubble shadow" *ngIf="!isMaximized" (click)="toggleChat()" [class.alert-mode]="unreadCount > 0" title="Abrir Chat Clínica">
        <i class="fa fa-comments"></i>
        <span class="badge bg-danger notification-dot" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
    </div>

    <div class="chat-widget-container" *ngIf="isMaximized">
        
        <div class="chat-custom-header" (click)="toggleChat()" [class.alert-mode]="unreadCount > 0">
            <span class="header-title">
                <i class="fa fa-comments mr-2"></i> Chat Clínica
                <span *ngIf="unreadCount > 0">({{ unreadCount }})</span>
            </span>

            <span class="header-status">
                <span class="status-dot"></span> Online
            </span>

            <span class="toggle-icon">
                <i class="fa fa-chevron-down cursor-pointer" title="Minimizar"></i>
            </span>
        </div>

        <div class="chat-content">
            <iframe *ngIf="chatUrl" [src]="chatUrl" title="Chat" class="chat-iframe"></iframe>
        </div>
        
    </div>
</ng-container>